import { useState } from 'react';
import { supabase } from '../../lib/supabase';
import { SYMPTOM_CATALOG, DEFAULT_ENABLED_SYMPTOMS } from '../../utils/wellness';
import './SymptomToggles.css';

export default function SymptomToggles({ clientId, client, onUpdate }) {
  const currentEnabled = client.enabled_symptoms || [];
  const [enabled, setEnabled] = useState(currentEnabled);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  function toggle(key) {
    setSaved(false);
    setEnabled((prev) => {
      if (prev.includes(key)) {
        return prev.filter((k) => k !== key);
      }
      return [...prev, key];
    });
  }

  function selectAll() {
    setSaved(false);
    setEnabled(DEFAULT_ENABLED_SYMPTOMS);
  }

  async function handleSave() {
    setSaving(true);
    const { data, error } = await supabase
      .from('clients')
      .update({ enabled_symptoms: enabled })
      .eq('id', clientId)
      .select();

    console.log('SymptomToggles save result:', { data, error, clientId, enabled });
    setSaving(false);
    if (error) {
      console.error('SymptomToggles save error:', error);
      alert('Failed to save: ' + error.message);
    } else {
      setSaved(true);
      if (onUpdate) onUpdate({ ...client, enabled_symptoms: enabled });
      setTimeout(() => setSaved(false), 2000);
    }
  }

  const hasChanges =
    JSON.stringify([...enabled].sort()) !==
    JSON.stringify([...currentEnabled].sort());

  return (
    <div className="symptom-toggles">
      <div className="st-header">
        <h3 className="st-title">Tracked Symptoms</h3>
        <p className="st-desc">
          Choose which symptoms this client logs daily. Disabled symptoms won't
          appear in their daily log.
        </p>
      </div>

      <div className="st-list">
        {SYMPTOM_CATALOG.map((symptom) => {
          const isOn = enabled.includes(symptom.key);
          return (
            <div
              key={symptom.key}
              className={`st-item ${isOn ? 'st-item-on' : 'st-item-off'}`}
              onClick={() => toggle(symptom.key)}
            >
              <span className="st-icon">{symptom.icon}</span>
              <div className="st-label-wrap">
                <span className="st-label">{symptom.label}</span>
                {symptom.subtitle && (
                  <span className="st-subtitle">{symptom.subtitle}</span>
                )}
              </div>
              <div className={`st-toggle ${isOn ? 'st-toggle-on' : ''}`}>
                <div className="st-toggle-knob" />
              </div>
            </div>
          );
        })}
      </div>

      <div className="st-actions">
        <button
          type="button"
          className="st-select-all"
          onClick={selectAll}
          disabled={enabled.length === DEFAULT_ENABLED_SYMPTOMS.length}
        >
          Select All
        </button>
        <button
          type="button"
          className="btn btn-primary st-save"
          onClick={handleSave}
          disabled={saving || !hasChanges}
        >
          {saving ? 'Saving...' : saved ? '✓ Saved' : 'Save Changes'}
        </button>
      </div>

      <p className="st-count">
        {enabled.length} of {SYMPTOM_CATALOG.length} symptoms active
      </p>
    </div>
  );
}
